// extracted by mini-css-extract-plugin
export default {"lottieContainer":"Loader_lottieContainer__TFtyd"};